import React from 'react';
import { Card } from '../Card';
import { CardProps } from '../types';

type PlaceholderCardProps = CardProps & {
  title: string;
  description?: string;
  placeholder: React.ComponentType;
};

export const PlaceholderCard: React.FC<PlaceholderCardProps> = ({ title, description, placeholder, icon }) => {
  const PlaceholderContent = placeholder;

  return (
    <Card title={title} icon={icon} description={description}>
      <PlaceholderContent />
    </Card>
  );
}
